import React from 'react';
import { ArrowRightIcon, CalculatorIcon, GitCompareArrowsIcon, MessageSquareIcon } from 'lucide-react';
interface HeroActionsProps {
  onFinance: () => void;
  onCompare: () => void;
  onInquiry: () => void;
}
const base = 'group flex flex-col rounded-3xl p-6 text-left transition-[background-color,border-color,box-shadow,transform] duration-200 ease-out hover:-translate-y-1 active:translate-y-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-neon focus-visible:ring-offset-2 focus-visible:ring-offset-ink sm:p-6';
export function HeroActions({
  onFinance,
  onCompare,
  onInquiry
}: HeroActionsProps) {
  const actions = [{
    label: 'Quiero financiar',
    hint: 'Simulá anticipo y cuotas fijas en pesos',
    icon: CalculatorIcon,
    onClick: onFinance,
    primary: true
  }, {
    label: 'Quiero comparar',
    hint: 'Precio, versión y equipamiento de hasta 3 unidades',
    icon: GitCompareArrowsIcon,
    onClick: onCompare,
    primary: false
  }, {
    label: 'Quiero dejar mi consulta',
    hint: 'Completá el formulario y te contactamos hoy',
    icon: MessageSquareIcon,
    onClick: onInquiry,
    primary: false
  }];
  return <div className="grid gap-4 lg:grid-cols-3" data-id="element-313" data-mp="j4sxrbkxbzf5">
      {actions.map(({
      label,
      hint,
      icon: Icon,
      onClick,
      primary
    }) => <button key={label} type="button" onClick={onClick} className={`${base} ${primary ? 'border border-neon-bright bg-neon text-ink shadow-neon-strong hover:bg-neon-bright' : 'border border-transparent bg-panel text-white shadow-neon hover:shadow-neon-strong'}`} data-id="element-314" data-mp="e7j8bvxjbnrb">
          <span className="flex items-center justify-between" data-id="element-315" data-mp="3rkmb5hjykurz">
            <span className={`flex h-12 w-12 items-center justify-center rounded-2xl ${primary ? 'bg-ink text-neon' : 'bg-neon/15 text-neon'}`} data-id="element-316" data-mp="1bui0btda87iv">
              <Icon className="h-6 w-6" aria-hidden="true" data-id="element-317" data-mp="1dyvbv8jntv01" />
            </span>
            <ArrowRightIcon className="h-6 w-6 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-318" data-mp="1e0zdfju36hx5" />
          </span>
          <span className="mt-6 whitespace-nowrap font-display text-2xl font-semibold leading-none tracking-tight lg:text-xl xl:text-2xl" data-id="element-319" data-mp="1nuq3uu9rx2fh">
            {label}
          </span>
          <span className={`mt-2 text-sm ${primary ? 'text-ink/80' : 'text-muted'}`} data-id="element-320" data-mp="v9orlh37wvc4">{hint}</span>
        </button>)}
    </div>;
}